/**
 * Generated bundle index. Do not edit.
 */

export * from './index';

export {BreadcrumbComponent as ɵa} from './lib/components/basic/widgets/breadcrumb.component';
export {LAYOUT_INIT_PROVIDERS as ɵb,init as ɵc} from './lib/providers/init.provider';